import { createHttpClient } from './httpClients';

export const ApiClientMain = createHttpClient(process.env.REACT_APP_API_URL!);
export const ApiClientEnterprise = createHttpClient(process.env.REACT_APP_API_ENTERPRISE_URL!);
export const ApiClientEnterpriseLinksReview = createHttpClient(
  process.env.REACT_APP_API_ENTERPRISE_LINKS_REVIEW_URL!,
);
export const ApiClientSocialMediaAutoSubmission = createHttpClient(
  process.env.REACT_APP_API_SOCIAL_MEDIA_AUTO_SUBMISSION_URL!,
);
